import axiosInstance from "./Axios";

export class FontApi {
  static ListSystemFonts = async (params?: {
    search?: string;
    page?: number;
    limit?: number;
  }) => {
    try {
      const res = await axiosInstance.get(`system-fonts/list`, { params });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching fonts!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static GetSystemFontsByIds = async (ids: string[]) => {
    try {
      if (!ids || ids.length === 0) {
        return { success: true, data: { docs: [] } };
      }

      const idsParam = ids.join(",");

      const res = await axiosInstance.get(`system-fonts/get-by-ids`, {
        params: { ids: idsParam },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching system fonts by ids!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static UploadFonts = async (
    formData: FormData,
    fontsFor: "agency" | "brand" = "agency",
  ) => {
    try {
      const endpoint =
        fontsFor === "brand" ? "/brand-fonts/upload" : "/agency-fonts/upload";

      const res = await axiosInstance.post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return {
        success: true,
        data: res.data.data,
      };
    } catch (err: any) {
      return {
        success: false,
        error: err?.response?.data?.message || "Font upload failed",
      };
    }
  };

  static GetFonts = async (params: {
    fonts_for: "agency" | "brand";
    agency_id?: string;
    brand_id?: string;
    page?: number;
    limit?: number;
    search?: string;
  }) => {
    try {
      const { fonts_for, ...restParams } = params;

      const endpoint =
        fonts_for === "brand" ? "/brand-fonts/fonts" : "/agency-fonts/fonts";

      const res = await axiosInstance.get(endpoint, { params: restParams });

      return {
        data: res.data.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching fonts!",
        success: false,
      };
    }
  };

  static RemoveFont = async (
    id: string,
    fontsFor: "agency" | "brand" = "agency",
  ) => {
    try {
      const endpoint =
        fontsFor === "brand"
          ? `brand-fonts/delete/${id}`
          : `agency-fonts/delete/${id}`;

      const res = await axiosInstance.delete(endpoint);

      return {
        success: true,
        data: res.data,
      };
    } catch (err: any) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while deleting font!",
      };
    }
  };

  static CreateAgencySettings = async (payload: {
    font_configuration: string;
    title_fonts?: string;
    subtitle_fonts?: string;
    body_text_fonts?: string;
  }) => {
    try {
      const res = await axiosInstance.post("/agency-settings/create", payload);

      return {
        success: true,
        data: res.data.data,
      };
    } catch (err: any) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while saving agency settings!",
      };
    }
  };

  static GetAgencySettings = async (params?: { agency_id?: string }) => {
    try {
      const res = await axiosInstance.get(
        "/agency-settings/fetch-agency-settings",
        {
          params,
        },
      );

      return {
        success: true,
        data: res.data.data,
      };
    } catch (err: any) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching agency settings!",
      };
    }
  };

  static UpdateAgencySettings = async (payload: {
    font_configuration?: string;
    title_fonts?: string;
    subtitle_fonts?: string;
    body_text_fonts?: string;
    open_home_posts?: {
      posting_window_days?: number;
    };
    auction_posts?: {
      posts_per_week?: number;
      final_call?: {
        enabled?: boolean;
        days?: number;
      };
    };
  }) => {
    try {
      const res = await axiosInstance.put(
        "/agency-settings/update-agency-settings",
        payload,
      );

      return {
        success: true,
        data: res.data.data,
      };
    } catch (err: any) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while updating agency settings!",
      };
    }
  };
}
